import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIconRegistry, MatIconModule } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { IDialogTimeoutModel } from 'src/app/modules/account/interfaces/dialog-model';

@Component({
  selector: 'app-timeout-error',
  templateUrl: './timeout-error.component.html',
  styleUrls: ['./timeout-error.component.scss'],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule]
})
export class TimeoutErrorComponent {

  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    public _dialogRef: MatDialogRef<TimeoutErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogTimeoutModel
  ) {
    iconRegistry.addSvgIcon('close', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/clear-24px.svg'));
  }

  onNoClick(): void {
    this._dialogRef.close();
  }

}
